import React from 'react'
import {
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  Button,
  Grid,
  Typography,
  IconButton,
  CircularProgress,
  Box,
} from '@mui/material'
import closeIcon from 'src/assets/icons/closeIcon.png'
type SimpleModalProps = {
  open: boolean
  onClose: () => void
  title?: string

  children?: React.ReactNode
}
const SimpleModal = ({
  open,
  onClose,
  title,

  children,
}: SimpleModalProps) => {
  return (
    <Dialog
      maxWidth='md'
      fullWidth
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          background: '#111111',
          borderRadius: '16px',
        },
        className: 'custom-scrollbar',
      }}
    >
      <Box>
        <DialogTitle>
          <Grid container justifyContent='end'>
            <IconButton onClick={onClose}>
              <img src={closeIcon} />
            </IconButton>
          </Grid>
          {title && (
            <Typography variant='h2' textAlign='center'>
              {title}
            </Typography>
          )}
        </DialogTitle>

        <DialogContent>{children}</DialogContent>
      </Box>
    </Dialog>
  )
}

export default SimpleModal
